import React from 'react';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import HowItWorks from './HowItWorks';
import CTASection from './CTASection';
const LandingPage = () => {
  return <div className="w-full" data-id="element-104">
      <HeroSection data-id="element-105" />
      <FeaturesSection data-id="element-106" />
      <HowItWorks data-id="element-107" />
      <CTASection data-id="element-108" />
    </div>;
};
export default LandingPage;